/*============================================================================
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - https://shopify.github.io/Timber/#ajax-cart

  Ajaxify the add to cart experience and flip the button for inline confirmation,
  show the cart in a modal, or a 3D drawer.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  JQUERY API (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
  
  Modified for MWTB Aug 2018. Many options and functions removed. Some functions added.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
Shopify.onProduct = function(product) {
};

Shopify.onCartUpdate = function(cart) {
};

Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onCartUpdate();
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItemWithParams = function(itemData, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: itemData,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {


      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onCartUpdate();
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if (callback == "returnCartJSON") {
      return cart;
    }
    else if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    }
    else {
      Shopify.onProduct(product);
    }
  });
};


Shopify.changeItem = function(variant_id, quantity, callback, line, props, revisedItem) {
  var queryData_Line = {
        quantity: quantity,
        line: line
      },
      queryData_ID = {
        quantity: quantity,
        id: variant_id
      },
      queryData_Props = {
        quantity: quantity,
        id: variant_id,
        properties: props
      };
  if ( props != undefined ) {
    queryData = queryData_Props;
  } else if ( line != undefined ) {
    queryData = queryData_Line;
  } else {
    queryData = queryData_ID;
  }

  
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: queryData,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart, revisedItem);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {

  'use strict';
  var init;
  var settings, cartInit, $cssTransforms, $cssTransforms3d, $w, $body, $html, $cartTotalNoPmtSelector, total_price_no_pmt, itemRow=0, imprintProofVariantID = 52361573007643;
  var $btnClass, $addToCart, $cartCountSelector, $cartCostSelector, $cartOriginalTotalPriceSelector, $subtotalItemsCountSelector, $itemItemsSelector, $modal, $cartContainer, $modalContainer, $modalOverlay, $closeCart, $drawerContainer
  var updateCountPrice, modalSetup, showModal, loadCartImages, itemAddedCallback, cartUpdateCallback, updateQuantity, buildCart, cartTemplate, adjustCart, adjustCartCallback;
  var saveNewImprint, addRevisedImprintItem, updateCartAfterImprintSwap, addImprintProof, itemDeleted, formatMoneyPlus, updateDiscountInfo, dayofYear;
  
  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  
  //does this fix IE?
  //jQuery.ajaxSetup({ cache: false });
  
  init = function (options) {
    settings = {
      formSelector: '#cartForm',
      cartCountSelector: '.cart-count',
      cartCostSelector: '.subtotal',
      cartOriginalTotalPriceSelector: '.originalTotalPrice',
      subtotalItemsCountSelector: '.itemsCount',
      itemItemsSelector: '.itemsCountLabel, #item-or-items',
      btnClass: 'btn',
      moneyFormat: '{{amount}}',
    };
    $.extend(settings, options);
    $btnClass          = settings.btnClass;
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $cartOriginalTotalPriceSelector  = $(settings.cartOriginalTotalPriceSelector);
    $subtotalItemsCountSelector = $(settings.subtotalItemsCountSelector);
    $itemItemsSelector = $(settings.itemItemsSelector);
    $modal             = null;
    $cssTransforms   = Modernizr.csstransforms;
    $cssTransforms3d = Modernizr.csstransforms3d;
    $w    = $(window);
    $body = $('body');
    $html = $('html');
    $cartTotalNoPmtSelector = $('#cartTotalNoPMT');

    modalSetup();
    adjustCart();
  };
  
  updateDiscountInfo = function(newTotal, newTotalNoPMT, itemDiscountCodes, cartTotalDiscount, cart) {
    let itemDiscountCodesTrimmed = Array.from(new Set(itemDiscountCodes));
    let itemDiscountCodesString = itemDiscountCodesTrimmed.join(", ");


    var totalDiscount = Shopify.formatMoney(cartTotalDiscount, settings.moneyFormat);
    $(".discount-alert-tiers").children("div").hide();
    $(".discount-alert-tier").children("p").hide();
    $(".discount-disclaimer").hide();
    if ( cartTotalDiscount > 0 ) {
      $("#appliedDiscountsSavings").html("<p class='cart-discount-total'>Discount <b>" + itemDiscountCodesString + "</b> saved you $" + totalDiscount + "</p>");
      $("#appliedDiscountsSavings").show();
    } else {
      $("#appliedDiscountsSavings").hide();
    }

    if (newTotalNoPMT >= 40000) {
      $("#discount-20").show();
      if (itemDiscountCodesTrimmed.includes("TAKE20")) {
        $("#discount-20-applied").show();
      } else {
        $("#discount-20-not-applied").show();
      }
    }
    else if (newTotalNoPMT >= 30000) {
      if (newTotalNoPMT >= 35000) {
        var teaserAmt = Shopify.formatMoney(40000-newTotalNoPMT, settings.moneyFormat);
        $(".cart-discount-next-tier").html(teaserAmt); 
        $(".cart-teaser").show();
      }
      $("#discount-15").show();
      if (itemDiscountCodesTrimmed.includes("TAKE15")) {
        $("#discount-15-applied").show();
      } else {
        $("#discount-15-not-applied").show();
      }
    }
    else if (newTotalNoPMT >= 20000) {
      if (newTotalNoPMT >= 25000) {
        var teaserAmt = Shopify.formatMoney(30000-newTotalNoPMT, settings.moneyFormat);
        $(".cart-discount-next-tier").html(teaserAmt); 
        $(".cart-teaser").show();
      }
      $("#discount-10").show();
      if (itemDiscountCodesTrimmed.includes("TAKE10")) {
        $("#discount-10-applied").show();
    } else {
        $("#discount-10-not-applied").show();
      }
    }
    else if (newTotalNoPMT >= 10000) {
      if (newTotalNoPMT >= 15000) {
        var teaserAmt = Shopify.formatMoney(20000-newTotalNoPMT, settings.moneyFormat);
        $(".cart-discount-next-tier").html(teaserAmt); 
        $(".cart-teaser").show();
      }
      $("#discount-5").show();
      if (itemDiscountCodesTrimmed.includes("TAKE5")) {
        $("#discount-5-applied").show();
      } else {
        $("#discount-5-not-applied").show();
      }
    }
    else {
      if (newTotalNoPMT >= 5000) {
        var teaserAmt = Shopify.formatMoney(10000-newTotalNoPMT, settings.moneyFormat);
        $(".cart-discount-next-tier").html(teaserAmt); 
        $(".cart-teaser").show();
      }
      
      $("#discount-email").show();
      $("#discount-none").show();
    }

    if (newTotalNoPMT < newTotal) {
      $(".discount-disclaimer").show();
    }

  };
  
  updateCountPrice = function (cart) {
    
    if ($subtotalItemsCountSelector) {
      $subtotalItemsCountSelector.html( cart.item_count );      
    }
    if ($itemItemsSelector) {
      $itemItemsSelector.html( cart.item_count == 1 ? "item" : "items" );
    }
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(formatMoneyPlus(cart.total_price));
    }
    if (cart.original_total_price > cart.total_price) {
      $cartOriginalTotalPriceSelector.html(" &nbsp;$" + formatMoneyPlus(cart.original_total_price));
    } else {
      $cartOriginalTotalPriceSelector.html("");
    }
  };

  modalSetup = function () {
 
    var source   = $("#modalTemplate").html(),
        template = Handlebars.compile(source);

    $cartContainer  = $('#cart-body');

    showModal(true);
  };

  showModal = function (toggle) {
    Shopify.getCart(cartUpdateCallback);
  };

  loadCartImages = function () {
    var cartImages = $('img', $cartContainer),
        count = cartImages.length,
        index = 0;

    cartImages.on('load', function() {
      index++;
    });
  };
  
  formatMoneyPlus = function (amount) {
      return Shopify.formatMoney(amount, settings.moneyFormat);
  
  }
  
  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    Shopify.getCart(cartUpdateCallback);
  };

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };
  
  addRevisedImprintItem = function (cart, revisedItem) {
    Shopify.addItemWithParams(revisedItem, updateCartAfterImprintSwap);
  };
  
  updateCartAfterImprintSwap = function (line_item) {
    Shopify.getCart(buildCart);
  }
  function updateQuantity(line, qty, key, id) {

    var row = $('.ajaxifyCart--row[data-key="' + key + '"]').addClass('ajaxifyCart--is-loading');
    var checkForLinkedProof = false;

    if ( qty === 0 ) {
      row.addClass('is-removed');
      checkForLinkedProof = true;
    } else {
      row.find(".updating-alert").show();
    }

    
    if ( checkForLinkedProof == true ) {
      setTimeout(function() {
        Shopify.changeItem(id, qty, function(cart) { itemDeleted(key); }, line);
      }, 500);
    } else {
      setTimeout(function() {
        Shopify.changeItem(id, qty, adjustCartCallback, line);
        //Shopify.changeItem(id, qty, cartUpdateCallback, line);
      }, 500);
    }
  }

  addImprintProof = function (cart, newImprintId, newTitle, newItemKey, keyChanged) {

    if ( keyChanged == true) {
      return;
    }

    var addProof = true,
        oldTitle = "",
        oldImprintID = "",
        origCartItemKey = "",
        oldItemKey = "";
    $.each(cart.items, function(index, cartItem) {
      if (cartItem.variant_id == imprintProofVariantID && cartItem.properties != null) {
        
        $.each(cartItem.properties, function(p_key, p_val) {
          if ( p_key == "Proof Item" ) {
            oldTitle = p_val;
          } else if ( p_key == "_Proof Imprint ID" ) {
            oldImprintID = p_val;
          } else if ( p_key == "_Proof Item Key" ) {
            oldItemKey = p_val;
          }
        });
        
        if ( oldTitle == newTitle && oldItemKey == newItemKey ) {
          addProof = false;
        } else if ( oldTitle == newTitle && oldItemKey == origCartItemKey ) {
          addProof = false;
        }
      }
    });
    
    if(addProof == true) {
      let proofItem = {
        id: imprintProofVariantID,
        quantity: 1,
        properties: {
          'Proof Item': newTitle,
          'Note': 'To remove this fee, delete the linked item',
          '_Proof Imprint ID': newImprintId,
          '_Proof Item Key': newItemKey
        }
      };
      Shopify.addItemWithParams(proofItem, updateCartAfterImprintSwap);
    }
  };
  
  
  itemDeleted = function (deletedItemKey) {
    
    var linkedItemKey = "";

    

    
    Shopify.getCart(function(cart) {
      
      $.each(cart.items, function(index, cartItem) {
        if (cartItem.variant_id == imprintProofVariantID && cartItem.properties != null) {
          
          $.each(cartItem.properties, function(p_key, p_val) {
            if ( p_key == "_Proof Item Key" ) {
              linkedItemKey = p_val;
            }
          });
          if ( linkedItemKey == deletedItemKey ) {
            updateQuantity(index+1, 0, cartItem.key, cartItem.id);
          }
        }
      });
      //adjustCartCallback(cart);
      cartUpdateCallback(cart);
    });
  }

  saveNewImprint = function (item,cartLine) {

    var itemProps = item['properties'];
    var imprintDetails = {
      t1: itemProps["Imprint Line 1"] || "",
      t2: itemProps["Imprint Line 2"] || "",
      t3: itemProps["Imprint Line 3"] || "",
      t4: itemProps["Imprint Line 4"] || "",
      t5: itemProps["Imprint Line 5"] || "",
      s1: itemProps["_Imprint Line 1 Styles"] || "",
      s2: itemProps["_Imprint Line 2 Styles"] || "",
      s3: itemProps["_Imprint Line 3 Styles"] || "",
      s4: itemProps["_Imprint Line 4 Styles"] || "",
      s5: itemProps["_Imprint Line 5 Styles"] || "",
      l: itemProps["Imprint Logo"] || itemProps["_Imprint Logo URL"] || "",
      ls: itemProps["_Imprint Logo Styles"] || "",
      ts: itemProps["_Imprint Time"] || Math.floor(Date.now()/1000)
    };
    var randomID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    var data = { 
      imprintID: randomID, 
      imprintDetails: imprintDetails 
    };

    var params = {
      type: 'POST',
      url: '/tools/imprint-saver/save-imprint',
      data: data,
      dataType: 'json',
      success: function(apiResult) {
        var resultType = apiResult.type,
            resultID = apiResult.id;

        var revisedItem = JSON.parse(JSON.stringify(item));
        revisedItem['properties']['_Imprint Saved ID'] = resultID;
        
        revisedItem['properties']['_Original Item Key'] = item.key;
        //revisedItem['properties']['_Imprint Time'] = imprintDetails['ts'];


        Shopify.changeItem(item.key, 0, addRevisedImprintItem, "", itemProps, revisedItem);
        //Shopify.changeItem(item.key, item.qty, "", "", revisedItem['properties']);
      },
      error: function(XMLHttpRequest, textStatus) {
      }
    };
    jQuery.ajax(params);
  };
  
  buildCart = function (cart) {
    $cartContainer.empty();
    if (cart.item_count === 0) {
      $(".cart-count").hide();
      $("#cart-full").slideUp(2000);
      $("#cart-empty").slideDown(500);
      $("#cart-empty-popular-items").delay(2000).slideDown(2000);
      return;
    }
    var items = [],
        item = {},
        data = {},
        allDiscountCodes = [];

    var source   = $("#cartTemplate").html(),
        template = Handlebars.compile(source);
    var forceRebuild = false,
        total_price_no_pmt = 0;

    $.each(cart.items, function(index, cartItem) {
      itemRow = index + 1;

      var itemAdd = cartItem.quantity + 1,
          itemMinus = cartItem.quantity - 1,
          itemQty = cartItem.quantity;
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', ''),
          prodName = cartItem.product_title,
          prodVarTitle = cartItem.variant_title || "",
          prodVarCleaned = prodVarTitle.replace('Standard (up to 3 weeks)','Printing Time: Standard (up to 3 weeks)').replace('Rush (1 week)','Printing Time: Rush (1 week)'),        
          prodVarCleaned = ( cartItem.sku.includes('PE99') && cartItem.properties['_Item Ship Delay'] > 0 ) ? "Printing Time: 1 Week / " + prodVarCleaned : prodVarCleaned, 
          prodVariation = prodVarCleaned || cartItem.product_title;
      var prodID = cartItem.id,
          imprintID = "",
          imprintApproval = "",
          origCartItemKey = "",
          keyChanged = false,
          showImprintNote = false,
          hideDeleteLink = false,
          propertiesHTML = "";
      if ( cartItem.product_title.indexOf('Personalized') != -1 || prodVariation.indexOf('Add Imprinting (+$5)') != -1 ) {
        showImprintNote = true;
      }
      if (cartItem.properties != null ) {
        $.each(cartItem.properties, function(p_key, p_val) {
          if ( p_key == "_Imprint Saved ID" ) {
            if ( customer.id != "" && p_val == "unsaved" ) {

              forceRebuild = true;
              saveNewImprint(cartItem,itemRow);
              keyChanged = true;
            } else if ( p_val != "unsaved" ) {
              
              imprintID = p_val;
            }
          }
          if ( p_key == "Imprint Approval" ) {
            imprintApproval = p_val;
          }
          if ( p_key == "_Original Item Key" ) {
            origCartItemKey = p_val;
          }
          if ( p_key == "_Proof Item Key" ) {
            hideDeleteLink = true;
          }


          if ( p_key.slice(0,1) != "_" && p_val != "" ) {
            propertiesHTML += p_key.replace("_", "").replace("Logo URL", "Logo") + ": ";
            if ( p_val.indexOf("/uploads/") != -1 ) {
              var uploadExtension = p_val.split('.').pop();
              if ( uploadExtension  == 'jpg' || uploadExtension  == 'jpeg' || uploadExtension  == 'png' || uploadExtension  == 'gif' ) {
               propertiesHTML += "&nbsp;<a data-fancybox href='" + p_val + "'><img src='" + p_val + "' width='25'></a>";
              } else {
               propertiesHTML += "&nbsp;Uploaded successfully";
              }
            } else {
              propertiesHTML += p_val.split(" ").splice(0,20).join(" ");
            }
            propertiesHTML += "<br />";
          }
        });
        if ( showImprintNote ) {
          propertiesHTML += "Your imprint styles have been saved";
        }
      }



      if ( imprintApproval == "Proof Required" ) {
forceRebuild = true;
        //addImprintProof(cart, imprintID, cartItem.sku, cartItem.key, keyChanged);
        addImprintProof(cart, imprintID, prodName, cartItem.key, keyChanged);
      }
      allDiscountCodes.push(...cartItem.discounts.map(discount => discount.title));

      var shippingHTML = shipping_dates_json[cartItem.key];
      if ( ( shippingHTML == "" || shippingHTML == undefined ) && origCartItemKey != "" ) {
        shippingHTML = shipping_dates_json[origCartItemKey];
      }
      var deleteLinkHTML = "<p class='cart-item-info cart-item-delete-link' data-id='" + cartItem.variant_id + "' data-key='" + cartItem.key + "' data-line='" + itemRow + "'><a href='javascript:;'>Delete</a></p>";
      if ( cartItem.variant_id == 52361573007643 && hideDeleteLink === true ) {
        deleteLinkHTML = "";
      }

      var discountsHTML = ( cartItem.vendor == "PrintMyTract.com" ) ? "<b>Please note:</b> Discount coupons do not apply to this item" : "";
      var qtyStaticHidden = "Hidden",
          qtyAdjustableHidden = "",
          hideQtySelectorForSKUs = "MI995714,MI996900";
      if ( hideQtySelectorForSKUs.includes(cartItem.sku) ) {
        qtyStaticHidden = "" ;
        qtyAdjustableHidden = "Hidden" ;
      }
      total_price_no_pmt = total_price_no_pmt + ( ( cartItem.vendor == "PrintMyTract.com" || cartItem.sku.includes( "DO99" ) ) ? 0 : cartItem.original_line_price );
      item = {
        id: cartItem.variant_id,
        key: cartItem.key,
        itemRow: itemRow,
        url: cartItem.url,
        img: prodImg,
        name: prodName,
        variation: prodVariation,
        properties: propertiesHTML,
        discounts: discountsHTML,
        shipping: shippingHTML,
        deleteLink: deleteLinkHTML,
        itemAdd: itemAdd,
        itemMinus: itemMinus,
        itemQty: itemQty,
        qtyStaticHidden: qtyStaticHidden,
        qtyAdjustableHidden: qtyAdjustableHidden,
        price: formatMoneyPlus(cartItem.price)
      };
      
      items.push(item);
    });
    allDiscountCodes.push(...cart.cart_level_discount_applications.map(discount => discount.title));
    updateDiscountInfo(cart.original_total_price, total_price_no_pmt, allDiscountCodes, cart.total_discount, cart);
    data = {
      items: items,
      totalPrice: formatMoneyPlus(cart.total_price),
      btnClass: $btnClass
    }
    $cartContainer.append(template(data));
    adjustCart(itemRow);

    loadCartImages();

    if (forceRebuild == false) {
      cartInit = true;
    }

  };

  adjustCart = function (itemRow) {

    var qtyAdjust = $('.ajaxifyCart--qty span');
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
      var el = $(this),
          key = el.data('key'),
          id = el.data('id'),
          line = el.data('line'),
          qtySelector = el.siblings('.ajaxifyCart--num'),
          qty = parseInt( qtySelector.val() );
      if (el.hasClass('ajaxifyCart--add')) {
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
      }
      if (line != undefined) {
        updateQuantity(line, qty, key, id);
      } else {
        qtySelector.val(qty);
      }

    });
    var qtyInput = $('.ajaxifyCart--num');
    qtyInput.off('change');
    qtyInput.on('change', function() {
      var el = $(this),
          key = el.data('key'),
          id = el.data('id'),
          line = el.data('line'),
          qty = el.val();
      if( (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ) {
      } else {
        el.val(1);
        return;
      }
      if (line != undefined) {
        updateQuantity(line, qty, key, id);
      }
    });
    qtyInput.off('focus');
    qtyInput.on('focus', function() {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
    });
    $('.cart-item-delete-link').click(function() {
      var el = $(this),
          key = el.data('key'),
          id = el.data('id'),
          line = el.data('line'),
          qty = 0;
      if (line != undefined) {
        updateQuantity(line, qty, key, id);
      }
    });
    $(".shipping-info-link").click(function() {
      $(this).children(".shipping-info").toggle();
    });
    if ( itemRow > 2 ) {
      $("#subtotal-top").slideDown();
    } else {
      $("#subtotal-top").slideUp();
    }
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
      var newNote = $(this).val();
      Shopify.updateCartNote(newNote, function(cart) {});
    });
      
//     if (typeof GoogleWalletButton === "function") GoogleWalletButton();
//     if (window.Shopify && Shopify.StorefrontExpressButtons) {
//       Shopify.StorefrontExpressButtons.initialize();
//     }
  };

  adjustCartCallback = function (cart) {

    updateCountPrice(cart);
    setTimeout(function() {
      Shopify.getCart(buildCart);
    }, 100)
  };

  module = {
    init: init
  };

  return module;

}(ajaxifyShopify || {}, jQuery));